import React from "react"
import { Popup } from "components"
import Button from "react-bootstrap/Button"
import "./index.scss"
import useT from "utils/hooks/useT"

// A component that asks the user for confirmation.
export default function ConfirmDialog({ children, onCancel, onConfirm, submitName }) {
  const { t } = useT("common")
  return (
    <Popup onCancel={() => onCancel()} className="ConfirmDialog">
      {children}
      <div className="ConfirmDialog-buttons">
        <Button variant="secondary" onClick={() => onCancel()}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={() => onConfirm()}>
          {submitName || t("confirm")}
        </Button>
      </div>
    </Popup>
  )
}
